export const languages = {
  enUS: 'en-US',
} as const

export const DEFAULT_LOCALE = languages.enUS

export const translationResources = Object.fromEntries(
  Object.values(languages).map((lang) => [
    lang,
    {
      translation: require(`./data/${lang}.json`),
    },
  ])
)
